import styled from 'styled-components';

export const Footer = styled.footer`
  width: 100%;
  height: 65px;

  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 5px;
  background-color: #9c27b0;
`;

export const ButtonFooter = styled.button`
  background-color: transparent;
  color: #fff;
  border: none;

  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 5px;
  justify-content: center;
  align-items: center;
  padding: 5px 10px;
`;
